import { Grid, MenuItem } from '@mui/material';
import React, { ReactElement } from 'react';
import _ from 'lodash';
import { GenericDropdown } from './GenericDropdown';
import { Endpoints, useApiRepo } from '../utils/Api';

export function ObsessionCompulsionFilter({ handleFilter }: any) {
  const [obsessions, setObsessions] = React.useState([]);
  const [selectedObsession, setSelectedObsession] = React.useState<any>({});
  const [selectedCompulsion, setSelectedCompulsion] = React.useState<any>({});

  const { getObjectsFromAPI } = useApiRepo();

  function handleSelectedObsession(event: any) {
    const selectedId = event.target.value;
    const ob = obsessions.find((obs: any) => obs.id === selectedId);
    if (ob) {
      setSelectedObsession(ob);
      handleFilter(ob);
    }
  }

  function handleSelectedCompulsion(event: any) {
    const selectedId = event.target.value;
    const ob = selectedObsession.compulsions.find(
      (comp: any) => comp.id === selectedId
    );
    if (ob) {
      setSelectedCompulsion(ob);
      handleFilter(selectedObsession, ob);
    }
  }

  function generateObsessionItems() {
    const menuItems: ReactElement<typeof MenuItem>[] = [];
    obsessions.map((obsession: any) =>
      menuItems.push(
        <MenuItem key={obsession.id} value={obsession.id}>
          {obsession.description}
        </MenuItem>
      )
    );
    return menuItems;
  }

  function generateCompulsionItems() {
    const menuItems: ReactElement<typeof MenuItem>[] = [];
    selectedObsession.compulsions.map((compulsion: any) =>
      menuItems.push(
        <MenuItem key={compulsion.id} value={compulsion.id}>
          {compulsion.compulsion}
        </MenuItem>
      )
    );
    return menuItems;
  }

  async function fetchObsessions() {
    const api = await getObjectsFromAPI();
    const res = await api.get<any>(Endpoints.obessions); // create a return type here
    setObsessions(res.data.data);
    generateObsessionItems();
  }

  React.useEffect(() => {
    fetchObsessions();
  }, []);

  return (
    <Grid container direction="row" spacing={2} justifyContent="center">
      <Grid item xs={12}>
        <GenericDropdown
          id="obsession_id"
          onChange={handleSelectedObsession}
          items={generateObsessionItems()}
          value={selectedObsession.id || ''}
          label="Obsession"
        />
      </Grid>
      <Grid item xs={12}>
        <GenericDropdown
          id="compulsion_id"
          onChange={handleSelectedCompulsion}
          items={!_.isEmpty(selectedObsession) ? generateCompulsionItems() : []}
          value={selectedCompulsion.id || ''}
          label="Compulsion"
          disabled={_.isEmpty(selectedObsession)}
        />
      </Grid>
    </Grid>
  );
}
